// extracted by mini-css-extract-plugin
export var completionBody = "_ch-2";
export var completionCard = "_ch-0";
export var completionFooter = "_ch-3";
export var completionTitle = "_ch-1";